import { setRegisteredData } from "./forms/registered-data";

let drawAnimation = null;

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

$('[name="personal_data[emailRepeat]"]').each(function() {
    let $email = $('[name="personal_data[email]"]', this.form.elements);
    let $emailRepeat = $('[name="personal_data[emailRepeat]"]', this.form.elements);
    $($email).add($emailRepeat).on('input', function() {
        $emailRepeat.toggleValid($email.val() == $emailRepeat.val());
    }).trigger('change');
});

$('.application-form').on('submit-success', function(event, data) {
    $('html, body').animate({
        scrollTop: $('#application').offset().top
    }, 10);
    $('.s-application-body').addClass('align-items-center');
    $('.page-form').addClass('d-none');
    $('.page-draw').removeClass('d-none');
    $('.draw-boxes').removeClass('disabled');
    $('.draw-boxes').find('.draw-boxes-disabled').addClass('d-none');
    let drawImage = '';

    let boxClass = '';

    if (data.prize) {
        drawImage = '/win.png';
        $('#go-to-winner-form').prop('href', data.formUrl);
        boxClass = 'yellow';
    } else {
        drawImage = '/loss.png';
        $('#go-to-winner-form').prop('href', '/');
        boxClass = 'red';
    }

    drawAnimation = setInterval(function () {
        $('.draw-boxes').find('.draw-box').each(function (key, item) {
            if ($(item).hasClass('red')) {
                const redArray = ['blue', 'yellow'];
                $(item).removeClass('red');
                $(item).addClass(redArray[Math.floor(Math.random() * redArray.length) | 0]);
            } else if ($(item).hasClass('blue')) {
                const blueArray = ['red', 'yellow'];
                $(item).removeClass('blue');
                $(item).addClass(blueArray[Math.floor(Math.random() * blueArray.length) | 0]);
            } else if ($(item).hasClass('yellow')) {
                const yellowArray = ['blue', 'red'];
                $(item).removeClass('yellow');
                $(item).addClass(yellowArray[Math.floor(Math.random() * yellowArray.length) | 0]);
            }
        });
    }, 500);

    setTimeout(function () {
        clearInterval(drawAnimation);
        const randIndex = Math.floor(Math.random() * 8);
        $('.draw-boxes').find('.draw-box').each(function (key, item) {
            if (key !== randIndex) {
                $(item).addClass('after-draw');
            } else {
                $(item).removeClass('red').removeClass('yellow').removeClass('blue').addClass(boxClass);
                $(item).find('svg').remove();
                $(item).append(`<img src="${drawImage}" alt="" />`);
            }
        });

        $('.page-draw').addClass('d-none');
        $(`.page-${data.prize ? 'win' : 'loss'}`).removeClass('d-none');
    }, 2500);
});

$('.game-run').on('click', function() {
    // page swap
    $('.page').addClass('d-none');
    $('.page-result').removeClass('d-none');
    $('.page-result').css('display', 'block');

    // modal (uncomment if you need modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('.page').addClass('d-none');
    $('.page-form').removeClass('d-none');
});

$('[name="personal_data[noPesel]"]').on('change', function() {
    $('[name="personal_data[pesel]"]', this.form.elements).prop('disabled', $(this).prop('checked'));
    let fields = [
        '[name="personal_data[citizenship]"]',
        '[name="personal_data[residentialAddress]"]',
    ];
    $(fields.join(', '), this.form.elements).closest('.form-group').prop('disabled', !$(this).prop('checked'));
}).trigger('change');

$('.winner-form').on('submit-success', function(event, data) {
    $('.form-container').remove();
    $('.after-fill').removeClass('d-none');
});

$('.contact-form').on('submit-success', function(event, data) {
    setRegisteredData(data, 'section#contact');

    // page swap
    $('.page').addClass('d-none');
    $('.page-thank-you').removeClass('d-none');
    $('.page-thank-you').css('display', 'block');

    // modal (uncomment if you need modal instead of page swap)
    //$('#modal-form-contact').modal('show');
});

$('.free-zone-form').on('submit-success', function(event, data) {
    $('.s-free-zone-heading').addClass('d-none');
    $('.s-free-zone-body').addClass('d-none');
    $(`.s-free-zone-${data.state}`).removeClass('d-none');
});

$('.back-to-free-zone').on('click', function () {
    $('.s-free-zone-loss').addClass('d-none');
    $('.s-free-zone-win').addClass('d-none');
    $('.s-free-zone-heading').removeClass('d-none');
    $('.s-free-zone-body').removeClass('d-none');
});
